module.exports = __webpack_public_path__ + "img/ctv-img.e9130a58.png";